import React from 'react';
import { withTranslation } from 'react-i18next';
import constants from '../due-date-calculator-constants/OC_Constants';
import DatePicker from "react-datepicker";
import Customdatepicker from './Customdatepicker';
import { isMobile } from 'react-device-detect';
import "react-datepicker/dist/react-datepicker.css";
import '../due-date-calculator-css/due-date-calendar-layout.css';
import 'react-input-range/lib/css/index.css'
import { registerLocale } from  "react-datepicker";
import enIN from 'date-fns/locale/en-IN';
registerLocale('enIN', enIN)

const currentdate = new Date()
const defaultview = true

class LastPeriod extends React.PureComponent {
	// Setting component default state here
	state = {
		cycleLengthValue: constants.DEFAULT_CYCLE_LENGTH, //Default value 
		dayValue: new Date().getDate(), // used for default selected value in dropdown
		monthValue: new Date().getMonth(), // used for default selected value in dropdown
		yearValue: new Date().getFullYear(), // used for default selected value in dropdown,
		periodDuration: constants.DEFAULT_PERIOD_DURATION,
		isPeriodChange: false,
		isCycleChange: false,
		showPlus: false,
		showRangeSlider: false,
		dplabel: this.props.parentCompData.lastperiodLabel.value,
		startDate: null,
		monthtoshown: isMobile ? 1 : 2,
		currentDate: new Date(),
		lastPeriodDateLogo: this.props.parentCompData.firstIcon.value,
		copen: defaultview,
		// fldpMaxDayRange: this.props.parentCompData.fdlpDateValidation.fields['Min Value'].value
		fldpMaxDayRange: this.props.parentCompData.fdlpDateValidation ?
		this.props.parentCompData.fdlpDateValidation.fields["Min Value"].value : 0

	};

	// This is LifeCycle method used to setup the default data for rendering
	componentDidMount() {
		let { cycleLength, periodDuration, dayValue, monthValue, yearValue } = this.props.currentMonthCycle
		if (cycleLength === 0) cycleLength = 28
		if (periodDuration === 0) periodDuration = 4
		this.setState((prevState, props) => {
			return {
				startDate: new Date(yearValue, monthValue, dayValue),
				cycleLengthValue: cycleLength,
				periodDuration: periodDuration
			};
		}, () => {
			this.props.sendLastPeriodData(this.state.dayValue, Number(this.state.monthValue), this.state.yearValue, this.state.cycleLengthValue, this.state.periodDuration, true, true, true);
		})
	}

	increasePeriod = () => {
		if (this.state.periodDuration < 10) {
			this.setState((prevState) => ({
				periodDuration: prevState.periodDuration + 1,
				isPeriodChange: true
			}), () => {
				this.props.sendLastPeriodData(new Date(this.state.startDate).getDate(),
					new Date(this.state.startDate).getMonth(),
					new Date(this.state.startDate).getFullYear(),
					this.state.cycleLengthValue,
					this.state.periodDuration,
					true,
					this.state.isPeriodChange, this.state.isCycleChange
				);
			})
		}
	}

	decreasePeriod = () => {

		if (this.state.periodDuration > 1) {
			this.setState((prevState) => ({
				periodDuration: prevState.periodDuration - 1,
				isPeriodChange: true
			}), () => {
				this.props.sendLastPeriodData(new Date(this.state.startDate).getDate(), new Date(this.state.startDate).getMonth(),
					new Date(this.state.startDate).getFullYear(), this.state.cycleLengthValue, this.state.periodDuration, true, this.state.isPeriodChange, this.state.isCycleChange);
			})
		}
	}

	increaseCycle = () => {
		if (this.state.cycleLengthValue < 38) {
			this.setState((prevState) => ({
				cycleLengthValue: prevState.cycleLengthValue + 1,
				isPeriodChange: true
			}), () => {
				this.props.sendLastPeriodData(new Date(this.state.startDate).getDate(),
					new Date(this.state.startDate).getMonth(),
					new Date(this.state.startDate).getFullYear(),
					this.state.cycleLengthValue,
					this.state.periodDuration,
					true,
					this.state.isPeriodChange, this.state.isCycleChange
				);
			})
		}

	}

	decreaseCycle = () => {

		if (this.state.cycleLengthValue > 21) {
			this.setState((prevState) => ({
				cycleLengthValue: prevState.cycleLengthValue - 1,
				isPeriodChange: true
			}), () => {
				this.props.sendLastPeriodData(new Date(this.state.startDate).getDate(), new Date(this.state.startDate).getMonth(),
					new Date(this.state.startDate).getFullYear(), this.state.cycleLengthValue, this.state.periodDuration, true, this.state.isPeriodChange, this.state.isCycleChange);
			})
		}

	}

	handleCalendarOpen = () => {
		if (this.state.copen) {
			this.setState({ copen: false })
		} else {
			this.setState({ copen: true })
		}
	}

	changeDate = (date) => {
		this.setState((prevState, props) => {
			return { startDate: date, copen: false };
		}, () => {
			// 		dayValue: new Date().getDate(), // used for default selected value in dropdown
			// monthValue: new Date().getMonth(), // used for default selected value in dropdown
			// yearValue: new Date().getFullYear(), // used for default selected value in dropdown,
			this.props.sendLastPeriodData(new Date(date).getDate(), new Date(date).getMonth(),
				new Date(date).getFullYear(), this.state.cycleLengthValue, this.state.periodDuration, true, this.state.isPeriodChange, this.state.isCycleChange);
		})
		// date => {
		// this.setState({startDate: date, copen: false})
		// }
	}

	handleCalendarClose = (event) => {
		this.setState({ copen: false })
		/*event.preventDefault() */
	}

	render() {
		const { t } = this.props;
		let { cycleLengthValue, isPeriodChange, isCycleChange } = this.state;
		let cycleLengthTextColor = isCycleChange ? '#212529' : '#bfccdd';
		// let currentmonthdays = new Date(this.state.currentDate.getFullYear(), this.state.currentDate.getMonth(), 0).getDate()
		// let prevmonthdays = new Date(this.state.currentDate.getFullYear(), this.state.currentDate.getMonth() - 1, 0).getDate()
		// let mindate = new Date(this.state.currentDate.getFullYear(), this.state.currentDate.getMonth() - 1, 1)
		// let maxdate = prevmonthdays + currentmonthdays
		let mindate = new Date().setDate(
			new Date().getDate() - this.state.fldpMaxDayRange + 1
		  );
		return (
			<>
				<div className="calculator-field" data-test="last-period">
					<div className="field field-datepicker">
						<label>{this.state.dplabel}
							<a className="ttlink" alt={t('DueDateCalculator_FirstDayOfPeriodInfo')}>
								<i className="fa fa-question-circle"></i>
								<span>{t('DueDateCalculator_FirstDayOfPeriodInfo')}</span>
							</a>
						</label>
						<DatePicker
							//ref={this.calendarRef}
							locale="enIN"
							// minDate={new Date(this.state.currentDate.getFullYear(), this.state.currentDate.getMonth() - 9, 1)}
							minDate={mindate}
							//maxDate={addDays(new Date(this.state.currentDate.getFullYear(), this.state.currentDate.getMonth() - 1, 1), maxdate)}
							maxDate={new Date()}
							dateFormat="dd MMMM, yyyy"
							showPopperArrow={false}
							selected={this.state.startDate}
							onChange={(date) => this.changeDate(date)}
							customInput={<Customdatepicker imagepath={this.state.lastPeriodDateLogo} placeholder="Select a date" />}
							showPreviousMonths={this.state.copen ? true : false}
							//showDisabledMonthNavigation
							monthsShown={this.state.monthtoshown}
							//onInputClick={() => this.handleCalendarOpen()}
							//onClickOutside={() => this.handleCalendarClose(this)}							
							//onClickOutside={() => {this.calendarRef.setOpen(false)}}>
							//open={this.state.copen}
							placeholderText="Select a date"
						>
						</DatePicker>
					</div>
				</div>

				<div className="duration-wrap">
					<label>{this.props.parentCompData.periodDayLabel.value}
						<a className="ttlink" alt={t('DueDateCalculator_CycleLengthInfo')}>
							<i className="fa fa-question-circle"></i>
							<span>{t('DueDateCalculator_CycleLengthInfo')}</span>
						</a>
					</label>
					<div className="input-group">
						<input type="button" value="-" className="button-minus" data-field="quantity" onClick={this.decreaseCycle} disabled={this.state.cycleLengthValue === 21} />
						<input type='text' id="period-cycle-length" readOnly className="period-cycle-range"
							value={`${cycleLengthValue}`}
							style={this.props.currentMonthCycle.cycleLength !== 0 ? { color: '#424C5F' } : { color: cycleLengthTextColor }} />
						<input type="button" value="+" className="button-plus" data-field="quantity" onClick={this.increaseCycle} disabled={this.state.cycleLengthValue === 38} />
					</div>
				</div>
			</>

		)
	}
}


export default withTranslation()(LastPeriod);